/* The filter at the top of Chat (chat tasks M2.4, GH #3041) */
.filter {
  flex: 0 0 auto;
  align-self: flex-start;
  margin: var(--tuna-spacing-1) var(--tuna-spacing-1_5);
}
